import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { CContributionTypes } from '../../constants/contributions.constants';

const { Option } = Select;

const ContributionCategory = () => {
    const { t } = useTranslation('forms', { keyPrefix: 'FORMS.INPUTS' });
    const { t: tr } = useTranslation('forms', { keyPrefix: 'FORMS.RULES' });

    const RULES = [{ required: true, message: tr('REQUIRED_FIELD') }];

    return (
        <Form.Item
            label={t('CONTRIBUTION.CATEGORY')}
            name="category"
            initialValue="IES"
            rules={RULES}
        >
            <Select
                placeholder={t('CONTRIBUTION.CATEGORY_PLACEHOLDER')}
            >
                {
                    CContributionTypes.map((type, index) => (
                        <Option value={type} key={index}>
                            {t(`CONTRIBUTION.${type}`)}
                        </Option>
                    ))
                }
            </Select>
        </Form.Item>
    );
};

export default ContributionCategory;
